import { Grid2, Paper } from "@mui/material";
import type { ReactNode } from "react";
import type { UtilityConsumptionMeter } from "../models/UtilityConsumption";
import {
	ConsumptionMeterTree,
	type ConsumptionMeterTreeLabels,
} from "./ConsumptionMeterTree";

interface ConsumptionFilterBarProps {
	meters: UtilityConsumptionMeter[];
	isMeterLoading: boolean;
	selectedMeterIds: string[] | null;
	meterLabels?: ConsumptionMeterTreeLabels;
	getMeterItemLabel?: (meter: UtilityConsumptionMeter) => string;
	areaSelector?: ReactNode;
	children?: ReactNode;
	actions?: ReactNode;
	onMeterChange: (meterIds: string[] | null) => void;
}

export const ConsumptionFilterBar = ({
	meters,
	isMeterLoading,
	selectedMeterIds,
	meterLabels,
	getMeterItemLabel,
	areaSelector,
	children,
	actions,
	onMeterChange,
}: ConsumptionFilterBarProps) => (
	<Paper
		component="section"
		aria-label="Consumption filters"
		elevation={0}
		variant="outlined"
		sx={{
			borderTopLeftRadius: 0,
			borderTopRightRadius: 0,
			mb: 1,
			px: 1.5,
			py: 1,
		}}
	>
		<Grid2 container spacing={1} alignItems="center">
			{areaSelector && (
				<Grid2 size={{ xs: 12, sm: 6, lg: "auto" }} sx={{ minWidth: 150 }}>
					{areaSelector}
				</Grid2>
			)}
			<Grid2 size={{ xs: 12, sm: 6, lg: "auto" }} sx={{ minWidth: 190 }}>
				<ConsumptionMeterTree
					meters={meters}
					isLoading={isMeterLoading}
					selectedMeterIds={selectedMeterIds}
					labels={meterLabels}
					getItemLabel={getMeterItemLabel}
					onMeterChange={onMeterChange}
				/>
			</Grid2>
			{children}
			{actions && (
				<Grid2 size={{ xs: 12, lg: "auto" }} sx={{ ml: { lg: "auto" } }}>
					{actions}
				</Grid2>
			)}
		</Grid2>
	</Paper>
);
